import { useEffect } from "react";
import { baseURL } from "../../../../constants/commonConstants";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { IFacultyWidgets } from "../../../../models/dashboard/facultyDashboard";
import { IWidgets } from "../../../../models/master/widgets";
import { useNavigate } from "react-router-dom";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { setWidgets } from "../../../../store/slices/master/widgetSlice";
import { connect, useDispatch } from "react-redux";
import { getWidgets } from "../../../../action/masters/widgetActionCreator";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const FacultyResourcesWidgets = (props: IFacultyWidgets) => {
  const { snapShots, widgets, getAllWidgets } = props;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const handleViewALL = () => {
    navigate(ROUTER_URL.RESOURCES);
  };

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.facultyResources
  );

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getAllWidgets(pageBlockId.facultyResources, limit.four);
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setWidgets([]));
    };
  }, []);

  return (
    <>
      <div
        className={
          pageBlockData?.displayOrNot ? "card-wrap" : "card-wrap card-snapshot"
        }
        style={
          pageBlockData?.displayOrNot === false
            ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
            : {}
        }
      >
        <div className="title">
          <h2>Faculty Resources</h2>
          <a
            className={
              pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
            }
            title="View All"
            onClick={handleViewALL}
          >
            View All
          </a>
        </div>
        <div className="row">
          {widgets
            ?.filter((widget: IWidgets) => widget.displayOrNot)
            .map((widget: IWidgets) => (
              <div className="col-xxl-6 mb-3" key={widget.id}>
                <a href={widget.url} target="_blank">
                  <div className="class-faculty">
                    <img
                      src={baseURL + widget.image}
                      alt=""
                      className="icon-img"
                    />
                    <h3 className="para-hide-1">{widget.name}</h3>
                    <p className="text">{widget.description.slice(0, 72)}</p>
                  </div>
                </a>
              </div>
            ))}
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getAllWidgets: (pageBlockId: number, noOfItems: number) =>
    getWidgets(undefined, pageBlockId,undefined, noOfItems),
};

function mapStateToProps(state: any) {
  return {
    widgets: state.widget.widgets,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FacultyResourcesWidgets);
